import React, { useEffect, useState } from 'react';

import icons from './../../../icons.svg';

const CalibrationProductDrawer = ({
  t,
  products,
  shelf,
  slot,
  showProductDrawer,
  closeProductDrawer,
  productSelection,
  selectedProduct,
}) => {
  const [calibrationProducts, setCalibrationProduct] = useState(products || []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selectedProduct]);

  const handleProductSearch = searchText => {
    if (!searchText) {
      setCalibrationProduct(products);
      return;
    }

    let visibleProducts = [];

    products.forEach(product => {
      if (
        product.barcode.toLowerCase().includes(searchText.toLowerCase()) ||
        product.name.toLowerCase().includes(searchText.toLowerCase())
      ) {
        visibleProducts.push(product);
      }
    });

    setCalibrationProduct(visibleProducts);
  };

  return (
    <div
      className={`calibration__drawer ${
        showProductDrawer ? 'calibration__drawer--open' : ''
      }`}
    >
      <div
        className="calibration__drawer-empty"
        onClick={() => closeProductDrawer(false)}
      >
        <div className="calibration__drawer-empty-close">
          <svg>
            <use xlinkHref={`${icons}#icon-close`}></use>
          </svg>
        </div>
      </div>
      <div className="calibration__drawer-products">
        <div className="calibration__selected">
          <span className="calibration__selected-shelf">
            {t('common:shelf')}: {shelf}
          </span>
          <span className="calibration__selected-slot">
            {t('common:slot')}: {slot}
          </span>
        </div>
        <p className="calibration__drawer-text">{t('common:selectProduct')}</p>
        <div className="calibration__drawer-search">
          <input
            type="text"
            placeholder="search product"
            onChange={e => handleProductSearch(e.target.value)}
          />
          <svg>
            <use xlinkHref={`${icons}#icon-search`}></use>
          </svg>
        </div>
        <ul>
          {calibrationProducts.map(product => {
            return (
              <li
                key={product.id}
                onClick={() => productSelection(product)}
                className={`${
                  selectedProduct.id === product.id
                    ? 'calibration__drawer-selected'
                    : ''
                }`}
              >
                {product.imageUrl && (
                  <img src={product.imageUrl} alt="produc image" />
                )}
                {!product.imageUrl && (
                  <svg>
                    <use xlinkHref={`${icons}#icon-cube`}></use>
                  </svg>
                )}
                <div className="calibration__drawer-products-info">
                  <span className="calibration__drawer-products-name">
                    {product.name}
                  </span>
                  <span className="calibration__drawer-products-barcode">
                    {product.barcode}
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default CalibrationProductDrawer;
